import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
  },
  date: {
    marginTop: '0 !important',
    marginBottom: '24px !important',
  },
}))
